/** Used when NEXT_PUBLIC_MAX_UPLOAD_SIZE_MB is unset or invalid. */
export const DEFAULT_MAX_UPLOAD_SIZE_MB = 50;

/**
 * Hard ceiling the env value is clamped to. Mirrors the
 * `file_size_limit` on the document Storage buckets
 * (`supabase/schema/03_tables/*_bucket.sql`) and the body
 * limits in `next.config.js`; signing-evidence and the
 * `supabase/config.toml` global limit sit at twice this.
 * Raise them all together.
 */
export const MAX_UPLOAD_SIZE_CEILING_MB = 100;
